export default __webpack_public_path__ + "static/media/single-project-page-04-img10.e3446093.jpg";